$(document).ready(function(){

  if($(".color_variant_title").length){
    var color_name = $('.product_color_swatch input[name="Color"]:checked').val();
    $(".color_variant_title").html(color_name);

    $(document).on("change",'.product_color_swatch input[name="Color"]',function(){
      var variant_val = $(this).val();
      $(".color_variant_title").html(variant_val);
    });
  }
  $(".mega-menu__content").removeClass("hidden")
  if($('.image_video_slider_trigger').length){
    $('.image_video_slider_trigger').slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false
    });
  
    var percentTime,tick, time = .1,progressBarIndex = 0;
    $('.progressBarContainer .progressBar').each(function(index) {
      var progress = "<div class='inProgress inProgress" + index + "'></div>";
      $(this).html(progress);
    });

    function startProgressbar() {
      resetProgressbar();
      percentTime = 0;
      tick = setInterval(interval, 10);
    }
  
    function interval() {
      if (($('.image_video_slider_trigger .slick-track .image_video_blocks[data-slick-index="' + progressBarIndex + '"]').attr("aria-hidden")) === "true") {
        progressBarIndex = $('.image_video_slider_trigger .slick-track .image_video_blocks[aria-hidden="false"]').data("slickIndex");
        startProgressbar();
      } else {
        percentTime += 1 / (time + 5);
        $('.inProgress' + progressBarIndex).css({
          width: percentTime + "%"
        });
        if (percentTime >= 100) {
          $('.image_video_slider_trigger').slick('slickNext');
          progressBarIndex++;
          if (progressBarIndex > 2) {
              progressBarIndex = 0;
          }
          startProgressbar();
        }
      }
    }
  
    function resetProgressbar() {
      $('.inProgress').css({
          width: 0 + '%'
      });
      clearInterval(tick);
    }
    startProgressbar();
  
    $('.banner_slider_item').click(function () {
      clearInterval(tick);
      var goToThisIndex = $(this).find("span").data("slickIndex");
      $('.image_video_slider_trigger').slick('slickGoTo', goToThisIndex, false);
      startProgressbar();
    });
  }

  $('.review_logo_slider_trigger').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    verticalSwiping: true,
    autoplay: true,
    arrows: false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
      vertical: false,
      verticalSwiping: false,
       speed: 5000, 
      autoplaySpeed: 0,
      variableWidth: true,
      cssEase: 'linear',
      swipeToSlide: true,
      centerMode: true,
      focusOnSelect: true
      }
    }
  ]
  });

  $('.services_list_trigger').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: false,
      verticalSwiping: false,
       speed: 8000, 
      autoplaySpeed: 0,
      variableWidth: true,
      cssEase: 'linear',
      swipeToSlide: true,
      centerMode: true,
      focusOnSelect: true
      }
    }
  ]
  });

  $('.product_grid_slider_trigger').each(function(){
    var $this = $(this);
    $this.slick({
      slidesToShow: 3,
      infinite: true,
      centerMode: true,
      swipeToSlide: true,
      speed: 200,
      dots: true,
      prevArrow: $this.parents(".featured_product_grid").find(".featured_prev_arrow"),
      nextArrow: $this.parents(".featured_product_grid").find(".featured_next_arrow"),
      responsive: [
         {
          breakpoint: 990,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  });


  $(".banner_image_review_slider").each(function(){
    var $this = $(this);
    $this.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000
    });
  });
  
  $('.customer-slider-body').slick({
    infinite: true,
    slidesToShow: 2.68,
    autoplay: false,
    arrows: false,
    // centerMode: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  })


    $("body.template_collection .js_light_heat_slider").each(function(){
      var $this = $(this);
      $this.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        prevArrow: $this.parents(".image_listing").find(".featured_prev_arrow"),
        nextArrow: $this.parents(".image_listing").find(".featured_next_arrow"),
        responsive: [ 
          {
            breakpoint: 1250,
            settings: {
               slidesToShow: 3
            }
          },
          {
            breakpoint: 850,
            settings: {
               slidesToShow: 2
            }
          },
          {
             breakpoint: 750,
             settings: {
                slidesToShow: 2,
                slidesPerRow :2,
                rows: 2
             }
          }   
        ]
      });
    });
  
    $("body:not(.template_collection) .js_light_heat_slider").each(function(){
      var $this = $(this);
      $this.slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        prevArrow: $this.parents(".image_listing").find(".featured_prev_arrow"),
        nextArrow: $this.parents(".image_listing").find(".featured_next_arrow"),
        responsive: [ 
          {
            breakpoint: 1250,
            settings: {
               slidesToShow: 3
            }
          },
          {
            breakpoint: 850,
            settings: {
               slidesToShow: 2
            }
          },
          {
             breakpoint: 750,
             settings: "unslick"
          }   
        ]
      });
    });
  

  $(document).on("click",".js_light_heat_tab",function(){
    var $this = $(this);
    var data_id = $this.attr("data_id");
    $(".js_light_heat_tab").removeClass("active");
    $(".js_light_heat_tab[data_id='"+data_id+"']").addClass("active");
    $this.parents(".light_heat_tabs").find(".images").addClass("hidden");
    $this.parents(".light_heat_tabs").find(".images[data_id='"+data_id+"']").removeClass("hidden");
    $this.parents(".light_heat_tabs").find(".content_description").addClass("hidden");
    $this.parents(".light_heat_tabs").find(".content_description[data_id='"+data_id+"']").removeClass("hidden");
    // lightHeat();
    $('.js_light_heat_slider').slick('setPosition');
  });

  $('.image_product_slider_trigger').each(function(){
    var $this = $(this);
    $this.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      prevArrow: $this.parents(".image_with_product").find(".featured_prev_arrow"),
      nextArrow: $this.parents(".image_with_product").find(".featured_next_arrow"),
      responsive: [ 
         {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
            
      ]
    });
  });

  $(document).on("click",".js_show_product",function(){
    var $this = $(this);
    $this.parents(".image_blocks").toggleClass("active");
  });

  $(document).on("click",".tabs_title",function(){
    if($(this).parents(".slide").hasClass("change_icon")){
      $(this).parent().find(".panel").slideUp();
      $(this).parents(".slide").removeClass("change_icon");
    }else{
      $(this).parents(".slider_main_containar").find(".panel").slideUp();
      $(this).parent().find(".panel").slideDown();
      $(this).parents(".slider_main_containar").find(".slide").removeClass("change_icon");
      $(this).parents(".slide").addClass("change_icon");
    }
  });

  $(document).on("click",".js_faq_heading",function(){
    var data_id = $(this).attr("data_id");
    $(".js_faq_heading").removeClass("active");
    $(this).addClass("active");
    var target_offset = $(".faq_list_block#"+data_id).offset().top - 150
    $('html, body').animate({scrollTop: target_offset}, 1000);
  });

  if($(".js_faq_heading").length){
    var lastId,menuItems = $(".faq_list_block"),
        scrollItems = menuItems.map(function(){
          var item = $(this);
          if (item.length) { return item; }
        });

    $(window).scroll(function(){
      var fromTop = $(this).scrollTop()+$(".header").height() + 250;
      var cur = scrollItems.map(function(){
        if ($(this).offset().top < fromTop)
          return this;
      });

      cur = cur[cur.length-1];
      var id = cur && cur.length ? cur[0].id : "";

      if (lastId !== id) {
        lastId = id;
        if(cur != undefined){
          var data_id = cur[0].id;
          $(".js_faq_heading").removeClass("active");
          $(".js_faq_heading[data_id='"+data_id+"']").addClass("active");
        }
      }                   
    });
  }

  $(document).on("change",".mobile_faq_type select",function(){
    var data_id = $(this).val();
    var target_offset = $(".faq_list_block#"+data_id).offset().top - 100
    $('html, body').animate({scrollTop: target_offset}, 1000);
  });

  $('.community_person_slider_trigger').each(function(){
    var $this = $(this);
    $this.slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      responsive: [ 
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }  
      ]
    });
  });
  // if ($(window).width() < 750) {
  //   $(".footer-block--menu .footer-block__heading").on("click" , function(){
  //     $(this).parents(".footer-block--menu").find(".footer-block__details-content").slideToggle();
  //     $(this).parents(".footer-block--menu").toggleClass("active")
  //   })
  // }

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    if(scroll > 1000){
      $(".section-header").addClass("logo_animation_revert");
    }else{
      $(".section-header").removeClass("logo_animation_revert");
    }
  });

  // var position = $(window).scrollTop(); 
  // $(window).scroll(function() {
  //   var scroll = $(window).scrollTop();
  //   if(scroll > 80){
  //     $(".section-header").removeClass("logo_animation_revert");
  //   }
  //   if(scroll < position) {
  //     $(".section-header").addClass("logo_animation_revert");
  //   } 
  //   position = scroll;
  // });

  $(document).on("click",".js_detail_tab",function(){
    $(".js_detail_tab").removeClass("active");
    $(this).addClass("active");
    var data_id = $(this).attr("data_id"); 
    $(this).parents(".product_details_tabs").find(".content").addClass("hidden");
    $(this).parents(".product_details_tabs").find(".content#"+data_id).removeClass("hidden");
    // $(this).parents(".product_details_tabs").find(".content.showmore").removeClass("showmore");
  });

  $('.customer_review_slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: true
  });

  $(document).on("change",".routline_variant_swatch input",function(){
    var data_id = $(this).attr("data_id");
    var variant_id = $(this).val();
    $(this).parents("form").find(".variant_title").text(data_id);
  });

  $(document).on("click",".js_size_guide",function(){
    $(".product_size_guide").removeClass("hidden");
    $("body").addClass("overflow-hidden");
    $('.js_size_guide_slider').slick('setPosition');
  });
  $(document).on("click",".close_popup",function(){
    $(".product_size_guide").addClass("hidden");
    $("body").removeClass("overflow-hidden");
  });
  $(document).on("click",".js_compare_product",function(){
    $(".compare_product_guide").removeClass("hidden");
    $("body").addClass("overflow-hidden");
  });
  $(document).on("click",".compare_close_popup",function(){
    $(".compare_product_guide").addClass("hidden");
    $("body").removeClass("overflow-hidden");
  });

  $(document).on("click",".drawer__inner .rebuy-button, .drawer__inner .rebuy-product-actions",function(){
    setTimeout(() => {
      $.ajax({
        url: '/?section_id=cart-drawer',
        type: 'GET',
        dataType: 'html',
        success:function(carthtml) {
          $("#CartDrawer").html($(carthtml).find('#CartDrawer').html());
          $("cart-drawer").removeClass("is-empty");
          $.getJSON('/cart.js',function(cart){
              $('.cart-count-bubble span').text(cart.item_count);
          });
        }
      });
    }, 2000);
  });

  $('.js_related_blog').each(function(){
    var $this = $(this);
    $this.slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: false,
      prevArrow: $this.parents(".related_blogs").find(".featured_prev_arrow"),
      nextArrow: $this.parents(".related_blogs").find(".featured_next_arrow"),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }  
      ]
    });
  });

  $(document).on("click",".cart_item_box .rebuy-button, .cart_item_box .rebuy-product-actions",function(){
    setTimeout(() => {
      $.ajax({
        url: '/?section_id=main-cart-items',
        type: 'GET',
        dataType: 'html',
        success:function(carthtml) {
          $("#checkout_order_summary").html($(carthtml).find('#checkout_order_summary').html());
          $("#main-cart-items").html($(carthtml).find('#main-cart-items').html());
          $.ajax({
            url: '/?section_id=cart-icon-bubble',
            type: 'GET',
            dataType: 'html',
            success:function(itemcount) {
              $("#cart-icon-bubble").html($(itemcount).html());
            }
          });
        }
      });
    }, 2000);
  });

  $(document).on("click",'.color_swatch input[type="radio"]',function(){
    var variant_image = $(this).attr("variant_image");
    $(this).parents(".product_list").find(".product_featured_image img").attr("src",variant_image);
  });
// ======start-community-page-tab=========
      $(".tab_list_inner").hide();
      $(".tab_list_inner").slice(0,8).show(); 
    $(".tab_title li").on("click" , function(){
      let title = $(this).attr("id");
      $(".tab_list_inner").hide().fadeOut("slow");
      $(this).addClass("active").siblings().removeClass("active"); 
      if($("#tab-all").hasClass("active")){
     $(".tab_list_inner:hidden").slice(0,8).show();
       if($(".tab_list_inner:hidden").length == 0){
         $(".js_show_all_member").fadeOut("slow");
        }else{
         $(".js_show_all_member").fadeIn("slow");
        }
      }else{
        console.log("elese")
        $(".tab_list_inner").hide();
        $(`.tab_list_inner[data-id= "${title}"]:hidden`).slice(0,8).show();
        if($(`.tab_list_inner[data-id= "${title}"]:hidden`).length == 0){
         $(".js_show_all_member").fadeOut("slow");
        }else{
         $(".js_show_all_member").fadeIn("slow");
        }
      }      
    })

     $(".js_show_all_member").click(function(e){
        e.preventDefault();        
       let btnclick = $(".js_ambassadors_list.active").attr("id")
     if($("#tab-all").hasClass("active")){
     $(".tab_list_inner:hidden").slice(0,8).fadeIn("slow"); 
      if($(".tab_list_inner:hidden").length == 0){
         $(".js_show_all_member").fadeOut("slow");
        }
      }else{
       console.log("elese")
        $(`.tab_list_inner[data-id= "${btnclick}"]:hidden`).slice(0,8).show();
        if($(`.tab_list_inner[data-id="${btnclick}"]:hidden`).length == 0){
         $(".js_show_all_member").fadeOut("slow");
        }        
      } 
 
  });
  if ($(window).width() < 768) {
    $(".filter_btn").on("click" , function(){
      $(".tab_title").slideToggle();
    })
    $(".tab_title li").on("click" , function(){
      $(".tab_title").slideUp();
    })
}

// ======end-community-page-tab=========
  $(".drawer_leavel_1 .first_leval").on("click" , function(){
    $(this).parents(".drawer_leavel_1").find(".drawer_leavel_2").slideToggle();
  });

  $(document).on("click",".cart_button .view_cart",function(){
    window.location.href = $(this).attr("href");
  });


  if ($(window).width() <= 767){
    $(document).on("click",".js_tab_box",function(){
      var data_id = $(this).attr("data_id");
      $(".js_tab_box").removeClass("active");
      $(this).addClass("active");
      $(this).parents(".detail_list").find(".content_image").addClass("hidden");
      $(this).parents(".product_work").find(".content_image").removeClass("hidden");
      var target_offset = $(this).offset().top - 100;
      $('html, body').stop().animate({scrollTop: target_offset}, 1000);
    });
  }

  $('.js_size_guide_slider').each(function(){
    var $this = $(this);
    $this.slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: false,
      prevArrow: $this.parents(".size_guide_label").find(".size_arrow_prev"),
      nextArrow: $this.parents(".size_guide_label").find(".size_arrow_next"),
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }  
      ]
    });
  });

  $(document).on("click",".js_size_heading_image",function(){
    var data_id = $(this).attr("data_id");
    $(".js_size_heading_image").removeClass("active");
    $(this).addClass("active");

    $(this).parents(".size_guide_image").find(".block_image .all_images").addClass("hidden_image");
    $(this).parents(".size_guide_image").find(".block_image .all_images#image_"+data_id).removeClass("hidden_image");
  });

  if ($(window).width() <= 767){
    $(document).on("click",".js_mobile_summary",function(){
      $(this).parents(".order_summury").find(".cart_order_summary_content").slideToggle();
    });
  }

  $(document).on("click",".product_recom .rebuy-button, .product_recom .rebuy-product-actions",function(){
    setTimeout(() => {
      $.ajax({
        url: '/?section_id=cart-drawer',
        type: 'GET',
        dataType: 'html',
        success:function(carthtml) {
          $("#CartDrawer").html($(carthtml).find('#CartDrawer').html());
          $("cart-drawer").removeClass("is-empty");
          $.ajax({
            url: '/?section_id=cart-icon-bubble',
            type: 'GET',
            dataType: 'html',
            success:function(itemcount) {
              $("#cart-icon-bubble").html($(itemcount).html());
              $(".cart-count-bubble").trigger("click");
            }
          });
        }
      });
    }, 2000);
  });

  if($(".product_work_section").length) {
    var r = document.querySelector(':root');
    var load_active_ele = $(".product_work:first-child").height() / 2;
    r.style.setProperty('--ember-dot-top', load_active_ele+'px');
    
    $(window).scroll(function(){
      var docViewBottom = $(window).scrollTop() + $(window).height();
      var elemTop = $('.product_work_section').offset().top;
      var data_ele_offset = $(".detail_list").offset().top;

      var menuItems = $(".product_work"),
      scrollItems = menuItems.map(function(){
        var item = $(this);
        if (item.length) { return item; }
      });

      var fromTop = $(this).scrollTop() + ($(window).height() / 2);
      var cur = scrollItems.map(function(){
        if ($(this).offset().top < fromTop){
         return $(this).attr("data");
        }
      });
      cur = cur[cur.length-1];
      if(elemTop < docViewBottom){
        if (cur != undefined) {
          var active_ele = $(".product_work[data='"+cur+"']");
          var selected_ele_height = ((active_ele.offset().top - data_ele_offset) + (active_ele.height() / 2));
          var r = document.querySelector(':root');
          r.style.setProperty('--ember-dot-top', selected_ele_height+'px');

          $(".product_work_details").find(".image").css({"opacity":"0","visibility":"hidden"});
          $(".product_work_details").find(".image#image_"+cur).css({"opacity":"1","visibility":"visible"});
        }
      }
    });
  }

  if ($(window).width() > 767){
    function activetabDot($this){
      var data_id = $this.attr("data_id");
      var data_ele_offset = $(".detail_list").offset().top;
      var active_ele = $(".product_work[data='"+data_id+"']");
      var selected_ele_height = ((active_ele.offset().top - data_ele_offset) + (active_ele.height() / 2));
      var r = document.querySelector(':root');
      r.style.setProperty('--ember-dot-top', selected_ele_height+'px');
  
      $this.parents(".product_work_details").find(".image").css({"opacity":"0","visibility":"hidden"});
      $this.parents(".product_work_details").find(".image#image_"+data_id).css({"opacity":"1","visibility":"visible"});
    }
    
    $(".js_tab_box").hover(function() {
      var $this = $(this)
      activetabDot($this)
    });
    $(document).on("click",".js_tab_box",function() {
      var $this = $(this)
      activetabDot($this)
    });
  }

  if($(".about_product_details").length){
    var r = document.querySelector(':root');
    var load_active_ele = ($(".about_product ul li:first-child").height() / 2) + 4;
      $(".about_product ul li:first-child").addClass("active");
    r.style.setProperty('--ember-dot-top', load_active_ele+'px');

    $(window).scroll(function(){
      var docViewBottom = $(window).scrollTop() + $(window).height();
      var elemTop = $('.about_product').offset().top;
      var data_ele_offset = $(".about_product ul").offset().top;

      var menuItems = $(".about_product ul li"),
      scrollItems = menuItems.map(function(){
        var item = $(this);
        if (item.length) { return item; }
      });

      var fromTop = $(this).scrollTop() + ($(window).height() / 2);
      var cur = scrollItems.map(function(){
        if ($(this).offset().top < fromTop){
         return $(this).attr("data");
        }
      });
      cur = cur[cur.length-1];
      
      if(elemTop < docViewBottom){
        if (cur != undefined) {
          var active_ele = $(".about_product ul li[data='"+cur+"']");
          $(".about_product ul li").removeClass("active");
          active_ele.addClass("active");
          var selected_ele_height = ((active_ele.offset().top - data_ele_offset) + (active_ele.height() / 2));
          var r = document.querySelector(':root');
          r.style.setProperty('--ember-dot-top', selected_ele_height+'px');
        }
      }
    });

    $(".about_product ul li").hover(function() {
      var $this = $(this)
      activetabDot($this)
    });
    $(document).on("click",".about_product ul li",function() {
      var $this = $(this)
      activetabDot($this)
    });

    function activetabDot($this){
      var data_id = $this.attr("data");
      var data_ele_offset = $(".about_product ul").offset().top;
      var active_ele = $(".about_product ul li[data='"+data_id+"']");
      $(".about_product ul li").removeClass("active");
      active_ele.addClass("active");
      var selected_ele_height = ((active_ele.offset().top - data_ele_offset) + (active_ele.height() / 2));
      var r = document.querySelector(':root');
      r.style.setProperty('--ember-dot-top', selected_ele_height+'px');
    }
  }

  $(document).on("click",".deferred-media",function(){
    $("body").addClass("overflow-hidden");
    document.querySelector(".product-media-modal").setAttribute("open", "open"); 
    $(".product-media-modal img.global-media-settings").addClass("hidden");
  });

  $(document).on("click",".product-media-modal__toggle",function(){
    console.log("call")
    $(".media-type-video .deferred-media__poster video")[0].play();
    $(".media-type-video .product__modal-opener video")[0].play();
  });
  $("body.template_index .single_block_list").hover(function(){
    $("body.template_index .single_block_list").removeClass("active");
    $(this).addClass("active");
  });
  if($(".js_size_heading_image").length){
    var current_product_id = $(".js_size_heading_image").attr("data-current-product-id");
    if($(".js_size_heading_image[data-product-id='"+current_product_id+"']").length){
      var current_data_id = $(".js_size_heading_image#block__"+current_product_id+"").parents(".size_heading").attr("data-slick-index");
      $(".js_size_heading_image#block__"+current_product_id+"").trigger( "click" );
      $('.js_size_guide_slider').slick('slickGoTo', current_data_id);
    }
  }
});

// if ($('.block__content-readmore-less-text').length) {
//   $('.block__content-readmore-less-text').on('click', function(event) {
//     event.preventDefault();
//     $(this).closest('.content').toggleClass('showmore');
//   });
// }

let isHeightSet = false;

function equl(name) {
  let heading = document.querySelectorAll(name);
  let maxHeight = 0;

  heading.forEach(el => {
    el.style.minHeight = "";
  });

  heading.forEach(el => {
    const height = el.offsetHeight;
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  heading.forEach(el => {
    el.style.height = (maxHeight + 20) + "px";
  });

  isHeightSet = true;
}
document.querySelectorAll(".tab_heading ul li").forEach(tabBtn => {
  tabBtn.addEventListener("click", function () {
    if (!isHeightSet) {
      setTimeout(() => {
        equl(".detail_content .content");
      }, 100);
    }
  });
});
window.addEventListener("load", () => {
  setTimeout(() => {
    equl(".detail_content .content");
    document.querySelectorAll('.detail_content .content').forEach((element, index) => {
      if (index !== 0) {
        element.classList.add('hidden');
      }
    });
  }, 100);
});